/**
 * As rotas.
 *
 * Um webchat tem três telas — fluxo, dados e configurações — e elas são **rotas aninhadas** dentro de
 * `WebchatLayout`, não abas de um componente. A diferença que isso faz: cada tela tem URL própria
 * (dá para mandar o link da aba de domínios para alguém), o botão Voltar do navegador funciona, e
 * Ctrl+clique abre em outra aba. Nada disso existia quando eram oito abas de um painel lateral.
 *
 * O preview fica **fora** do layout de propósito: é tela cheia, com cabeçalho próprio, e costuma ser
 * aberta numa segunda aba enquanto o editor segue em uso na primeira.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider.js';
import { DataPage } from './pages/DataPage.js';
import { FlowPage } from './pages/FlowPage.js';
import { ListPage } from './pages/List.js';
import { LoginPage } from './pages/Login.js';
import { PreviewPage } from './pages/Preview.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { WebchatLayout } from './pages/WebchatLayout.js';

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">Carregando…</div>;
  }

  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route path="/" element={<ListPage />} />

      <Route path="/w/:id" element={<WebchatLayout />}>
        <Route index element={<FlowPage />} />
        <Route path="dados" element={<DataPage />} />
        {/* Com e sem seção: `/config` cai na primeira, `/config/dominios` abre a que se pediu. */}
        <Route path="config" element={<SettingsPage />} />
        <Route path="config/:section" element={<SettingsPage />} />
      </Route>

      {/* Tela dedicada ao preview: pode ser aberta em outra aba enquanto o editor segue em uso. */}
      <Route path="/w/:id/preview" element={<PreviewPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
